<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">电子处方流转管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          电子处方流转管理系统打通医院 HIS 系统与定点零售药店，实现处方开具、药师审核、处方流转、药品调配、医保结算与全程追溯的一体化管理。患者在院内就诊后，可自主选择院内取药或院外定点药店购药，有效解决“取药排队久、院外购药难”问题，提升群众就医购药便利度。
        </p>
        <p class="content-paragraph">
          系统以处方数据安全共享为核心，采用电子签名与加密传输保障处方真实性与可追溯性；面向医疗机构提供处方外流管理与合理用药监测，面向药店提供接单调配与结算对账，面向监管部门提供处方流向追溯、抗菌药物管控与用药行为分析，实现“处方流得动、药品配得出、费用结得了、风险管得住”。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">处方流转</h3>
            <ul class="capability-list"><li>处方上传</li><li>药师审方</li><li>处方外流</li><li>电子签名</li><li>患者选店</li><li>流转状态跟踪</li><li>处方撤回</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">调配与结算</h3>
            <ul class="capability-list"><li>药店接单</li><li>药品调配</li><li>医保结算</li><li>在线支付</li><li>药品配送</li><li>处方留存</li><li>对账清算</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">监管与追溯</h3>
            <ul class="capability-list"><li>处方合规审查</li><li>抗菌药物管控</li><li>流向追溯</li><li>合理用药分析</li><li>异常预警</li><li>统计报表</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/cf-flow.svg"
              alt="海南华德科技有限公司 电子处方流转管理系统 - 处方流转 · 审方与院外购药"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>处方流转 · 审方与院外购药
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/cf-mobile.svg"
              alt="海南华德科技有限公司 电子处方流转管理系统 - 患者端 · 自主选店与医保结算"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>患者端 · 自主选店与医保结算
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/cf-supervise.svg"
              alt="海南华德科技有限公司 电子处方流转管理系统 - 监管追溯 · 合理用药与风险管控"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>监管追溯 · 合理用药与风险管控
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/cf-settle.svg"
              alt="海南华德科技有限公司 电子处方流转管理系统 - 结算对账 · 医保结算与清算管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>结算对账 · 医保结算与清算管理
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs12.vue